import { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Logo from "./images/data-enrichment-process.png";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: "10px 10px 0 0", // top-left & top-right corners only
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // soft bottom shadow
  marginBottom: "10px", // space between accordions
  overflow: "hidden",
  "&:not(:first-of-type)": {
    borderTop: "1px solid #ddd", // optional subtle border
  },
}));

export default function ControlledAccordion() {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <StyledAccordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h5">What is data enrichment?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Data enrichment is the process of adding more useful information to
            existing 1P data to make it clearer, more complete, and more
            valuable.
          </Typography>
        </AccordionDetails>
      </StyledAccordion>

      <StyledAccordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h5">How to achieve data enrichment?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <img
            style={{
              objectFit: "contain",
              justifyContent: "center",
              width: "80%",
              height: "60%",
            }}
            src={Logo}
            alt="!"
          />
          <br />
          <div>
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 500 }}>Step 1:</span> Define Audience
              Cohorts — The brand or agency needs to define the audience cohorts
              to target, which could be a combination of multiple available data
              fields on the audience discovery platform.
            </div>
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 500 }}>Step 2:</span> Multiple
              Contributors Involvement — When audience parameters are defined,
              contributors are selected by the system based on multiple
              protocols and availability. Requests are raised to respective
              contributors.
            </div>
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 500 }}>Step 3:</span> Audience
              Overlapping — Audience subsets from multiple contributors are
              intersected to form complete audience intelligence.
            </div>
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 500 }}>Step 4:</span> Ready the Data
              Sets —
              <br />
              <strong>Provider Dataset:</strong> Built from multiple
              contributors’ intelligence.
              <br />
              <strong>Consumer Dataset:</strong> Contains customer/user data
              linked to Snowflake.
            </div>
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 500 }}>Step 5:</span> Match Rate —
              Identify a common key, run a match query in the clean room,
              deduplicate, and compute the match rate.
            </div>
          </div>
        </AccordionDetails>
      </StyledAccordion>
    </div>
  );
}
